import { Component } from '@theme/component';

/**
 * Drop Countdown Component
 * Handles countdown timers and status displays for drop products
 */
export class DropCountdown extends Component {
  constructor() {
    super();
    this.countdownInterval = null;
    this.dropDate = null;
    this.status = null;
  }

  connectedCallback() {
    super.connectedCallback();
    
    // Get data from the countdown overlay element itself
    this.dropDate = this.dataset.dropDate;
    
    // Get status from parent card gallery
    const cardGallery = this.closest('.card-gallery');
    if (cardGallery) {
      this.status = cardGallery.dataset.countdownStatus;
    }

    console.log('DropCountdown: connectedCallback - dropDate:', this.dropDate, 'status:', this.status);

    // Always initialize if we have a drop date
    if (this.dropDate) {
      this.initializeCountdown();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  initializeCountdown() {
    console.log('DropCountdown: initializeCountdown called');
    this.updateCountdown();
    
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    console.log('DropCountdown: updateCountdown called with dropDate:', this.dropDate);
    
    const now = new Date().getTime();
    const dropTime = new Date(this.dropDate).getTime();
    const timeLeft = dropTime - now;

    console.log('DropCountdown: updateCountdown - now:', now, 'dropTime:', dropTime, 'timeLeft:', timeLeft);

    if (timeLeft <= 0) {
      // Drop time reached - update display
      this.updateToActive();
      return;
    }

    // Update countdown display
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

    console.log('DropCountdown: Calculated time - days:', days, 'hours:', hours, 'minutes:', minutes);

    // This element IS the countdown overlay
    const daysElement = this.querySelector('.countdown-days');
    const hoursElement = this.querySelector('.countdown-hours');
    const minutesElement = this.querySelector('.countdown-minutes');

    console.log('DropCountdown: Found elements - days:', daysElement, 'hours:', hoursElement, 'minutes:', minutesElement);

    if (daysElement) {
      daysElement.textContent = days.toString().padStart(2, '0');
      console.log('DropCountdown: Updated days to:', daysElement.textContent);
    }
    if (hoursElement) {
      hoursElement.textContent = hours.toString().padStart(2, '0');
      console.log('DropCountdown: Updated hours to:', hoursElement.textContent);
    }
    if (minutesElement) {
      minutesElement.textContent = minutes.toString().padStart(2, '0');
      console.log('DropCountdown: Updated minutes to:', minutesElement.textContent);
    }
  }

  updateToActive() {
    // Update the data attribute
    const cardGallery = this.closest('.card-gallery');
    if (cardGallery) {
      cardGallery.dataset.countdownStatus = 'active';
    }

    // Status badge update - REMOVED

    // Remove this countdown overlay
    this.remove();
    
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    // Update status variable
    this.status = 'active';
  }
}

if (!customElements.get('drop-countdown')) {
  customElements.define('drop-countdown', DropCountdown);
}

// Also define as card-gallery-countdown for the overlay elements
if (!customElements.get('card-gallery-countdown')) {
  customElements.define('card-gallery-countdown', DropCountdown);
}

/**
 * Product Card Enhancement for Drops
 * Adds drop countdown functionality to product cards
 */
export class DropProductCard extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Check if this product card has countdown functionality
    const hasCountdown = this.classList.contains('product-card--countdown');
    const status = this.dataset.countdownStatus;
    
    if (hasCountdown && status === 'upcoming') {
      // Initialize countdown for this product card
      const countdown = new DropCountdown();
      countdown.dropDate = this.dataset.dropDate;
      countdown.status = status;
      countdown.initializeCountdown();
      
      // Store reference to countdown
      this.countdown = countdown;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.countdown) {
      this.countdown.disconnectedCallback();
    }
  }
}

if (!customElements.get('drop-product-card')) {
  customElements.define('drop-product-card', DropProductCard);
}

// Initialize countdowns for all card galleries on page load
document.addEventListener('DOMContentLoaded', () => {
  console.log('DropCountdown: DOMContentLoaded - checking for countdown elements');
  
  // The countdown elements should be automatically initialized as custom elements
  const countdownElements = document.querySelectorAll('card-gallery-countdown');
  console.log('DropCountdown: Found', countdownElements.length, 'countdown elements');
  
  countdownElements.forEach((element, index) => {
    console.log(`DropCountdown: Element ${index + 1} - dropDate:`, element.dataset.dropDate);
  });
});

// Also initialize when new content is loaded (for dynamic content)
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const newGalleries = node.querySelectorAll ? node.querySelectorAll('.card-gallery[data-countdown-status="upcoming"]') : [];
        newGalleries.forEach((gallery) => {
          const status = gallery.dataset.countdownStatus;
          const dropDate = gallery.dataset.dropDate;
          
          if (status === 'upcoming' && dropDate) {
            const countdownElement = gallery.querySelector('.card-gallery__countdown-overlay');
            if (countdownElement && !gallery.countdown) {
              const countdown = new DropCountdown();
              countdown.dropDate = dropDate;
              countdown.status = status;
              countdown.initializeCountdown();
              gallery.countdown = countdown;
            }
          }
        });
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
}); 